import { render, staticRenderFns } from "./ReplyQuestion.vue?vue&type=template&id=270688e8"
import script from "./ReplyQuestion.vue?vue&type=script&lang=js"
export * from "./ReplyQuestion.vue?vue&type=script&lang=js"
import style0 from "./ReplyQuestion.vue?vue&type=style&index=0&id=270688e8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports